module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-beijing-h5.9dae5a65.jpg";